import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { useEffect } from "react";
import LeverageQuizPage from "./pages/LeverageQuizPage";
import PractitionerQuizPage from "./pages/PractitionerQuizPage";
import TryProductsPage from "./pages/TryProductsPage";
import AdminPage from "./pages/AdminPage";
import AdminLeadsPage from "./pages/AdminLeadsPage";
import ProductsThankYouPage from "./pages/ProductsThankYouPage";
import { CookieBanner } from "./components/CookieBanner";

// Redirect component for external URLs
function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <AnimatePresence mode="wait">
        <Routes>
          {/* Main quiz page */}
          <Route path="/" element={<LeverageQuizPage />} />
          <Route path="/practitioners" element={<PractitionerQuizPage />} />
          
          {/* Try products page - UNTOUCHED */}
          <Route path="/try-products" element={<TryProductsPage />} />
          <Route path="/try-products/thank-you" element={<ProductsThankYouPage />} />
          
          {/* Admin pages */}
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/leads" element={<AdminLeadsPage />} />
          
          {/* Redirects (301 equivalent - Navigate with replace) */}
          <Route path="/quiz" element={<Navigate to="/" replace />} />
          <Route path="/results" element={<Navigate to="/" replace />} />
          <Route path="/bridge" element={<Navigate to="/" replace />} />
          <Route path="/start-business" element={<ExternalRedirect to="https://kristenhinman.com/run-it" />} />
          <Route path="/start-business/thank-you" element={<Navigate to="/" replace />} />
          
          {/* Catch-all redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AnimatePresence>
      <CookieBanner />
    </BrowserRouter>
  );
}

export default App;
